const testimonials = [
  {
    name: "Leti Fernandez",
    quote:
      "I was extremely happy with the service I received from NW Trucking of NC. The sales representative was very personable and helpful. The moving team was very efficient, very thorough, and very fast. I was surprised at how quick they are.",
  },
  {
    name: "Julia Lambert",
    quote:
      "Terrific! Our third move with NW Trucking of NC went the same as the others--perfect and without a hitch. The sales and support were fine, and the moving crew was excellent. Carl and his team are really skilled and careful movers.",
  },
  {
    name: "Diana Moody",
    quote:
      "These guys were great! They didn't arrive on time...they were EARLY! They were so quick and efficient that I would look one minute, the next, the item would already be out of the house. These guys are truly the A-team!",
  },
];

export default function TestimonialsSection() {
  return (
    <section className="w-full px-6 md:px-10 lg:px-20 py-16 md:py-24 bg-background-50 relative overflow-hidden">
      {/* Decorative large curved path – matches source site background */}
      <div className="absolute top-0 right-0 w-[55%] h-full opacity-[0.035] pointer-events-none">
        <svg viewBox="0 0 600 900" preserveAspectRatio="none" className="w-full h-full">
          <path d="M600,0 Q120,450 600,900" fill="none" stroke="#7c3aed" strokeWidth="220"/>
        </svg>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">

          {/* Testimonial cards – left 2/3 */}
          <div className="w-full lg:w-[62%]">
            {/* Top row: 2 cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              {testimonials.slice(0, 2).map((t) => (
                <div
                  key={t.name}
                  className="bg-background-50 border border-background-200/70 rounded-xl p-6"
                >
                  <div className="w-9 h-9 rounded-full bg-accent-500 flex items-center justify-center mb-4">
                    <div className="w-4 h-4 flex items-center justify-center text-white">
                      <i className="ri-double-quotes-l text-sm" />
                    </div>
                  </div>
                  <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                    &ldquo;{t.quote}&rdquo;
                  </p>
                  <p className="text-xs font-bold text-foreground-900">
                    — {t.name}
                  </p>
                </div>
              ))}
            </div>

            {/* Bottom: 1 card offset to right – matching source stagger */}
            <div className="mt-5 flex justify-end">
              <div className="w-full md:w-[calc(50%-10px)]">
                <div className="bg-background-50 border border-background-200/70 rounded-xl p-6">
                  <div className="w-9 h-9 rounded-full bg-accent-500 flex items-center justify-center mb-4">
                    <div className="w-4 h-4 flex items-center justify-center text-white">
                      <i className="ri-double-quotes-l text-sm" />
                    </div>
                  </div>
                  <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                    &ldquo;{testimonials[2].quote}&rdquo;
                  </p>
                  <p className="text-xs font-bold text-foreground-900">
                    — {testimonials[2].name}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Header – right 1/3 */}
          <div className="w-full lg:w-[38%] flex flex-col justify-center space-y-4">
            <p className="text-[11px] font-semibold tracking-[0.35em] text-foreground-400 uppercase">
              TESTIMONIAL
            </p>
            <h2 className="text-[1.75rem] md:text-[2rem] lg:text-[2.4rem] font-extrabold text-foreground-900 leading-tight">
              What our{" "}
              <span className="text-accent-500">customer</span> say
            </h2>
            <p className="text-[0.9rem] text-foreground-500 leading-relaxed">
              The best marketing for our company is the word of mouth of our
              clients. Check out what they have to say.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}